
import { Button, Input, Select, SelectItem } from '@nextui-org/react'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import { useSelector } from 'react-redux';

const UpdateTrip = () => {
    const navigate = useNavigate();
    const [gpiNo, setgpiNo] = useState();

    const { user } = useSelector(state => state.user);

    const { id } = useParams();

    const [loading, setloading] = useState(true);

    const [tripData, setTripData] = useState();

    // state for storing remarks
    const [selectedAdvancedRemark, setSelectedAdvancedRemark] = useState(["NEFT"]);
    const [postpaidRemark1, setPostpaidRemark1] = useState(["NEFT"]);
    const [postpaidRemark2, setPostpaidRemark2] = useState(["NEFT"]);
    const [postpaidRemark3, setPostpaidRemark3] = useState(["NEFT"]);
    const [extraAmountRemark, setExtraAmountRemark] = useState(["NEFT"]);


    useEffect(() => {
        (async () => {
            try {
                setloading(true);
                const response = await axios.get(`/trip/${id}`);
                setloading(false);
                if (response.data.success) {
                    setTripData(response.data.tripData);

                    //setting remarks states
                    setSelectedAdvancedRemark([
                        response.data.tripData?.advanceAmountRemark?.trim() || "NEFT"
                    ]);

                    setPostpaidRemark1([
                        response.data.tripData?.postPaidAmountRemark?.trim() || "NEFT"
                    ]);

                    setPostpaidRemark2([
                        response.data.tripData?.postPaidAmountRemark2?.trim() || "NEFT"
                    ]);

                    setPostpaidRemark3([
                        response.data.tripData?.postPaidAmountRemark3?.trim() || "NEFT"
                    ]);

                    setExtraAmountRemark([
                        response.data.tripData?.extraAmountRemark?.trim() || "NEFT"
                    ]);

                }
            } catch (error) {
                toast.error(error.response.data.message);
            }
        })();
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const formdata = new FormData(e.target);
            const data = Object.fromEntries(formdata.entries());
            // console.log(data);

            let filteredData = {}
            for (let key in data) {
                if (data[key]) {
                    filteredData = { ...filteredData, [key]: data[key] }
                }
            }
            // console.log(filteredData);


            if (Object.keys(filteredData).length === 0) {
                toast.error("Please provide a field!");
                return;
            }

            try {
                const response = await axios.put(`/trip/updateTrip/${tripData._id}`, filteredData);
                if (response.data.success) {
                    toast.success(response.data.message);
                    navigate("/all-records");
                }
            } catch (error) {
                toast.error(error.response.data.message);
            }

        } catch (error) {

            toast.error(error.response.data.message);
        }
    }

    const star = <span className="text-red-600 font-bold">*</span>;

    if (loading) {
        return <Loader />
    }

    return (
        <>
            <div className="flex justify-center items-center">
                <form
                    onSubmit={handleSubmit}
                    className="flex flex-col w-[90vw] sm:w-[60vw]  lg:w-[50vw] justify-center items-center border-2 p-10 pb-2 my-5 gap-6 rounded-lg">

                    <h1 className="underline font-bold">Update Trip</h1>

                    <div className="flex gap-4 w-full">
                        <div className='w-3/5'>
                            <label htmlFor="date-time" className="text-sm pl-3">Date-time {star}</label>
                            <Input type="text" variant='underlined' id="date-time" name="tripDate"
                                placeholder={new Date(tripData?.tripDate).toLocaleDateString() + " " + new Date(tripData?.tripDate).toLocaleTimeString()} isDisabled />
                        </div>
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="gpiNo"
                            isRequired
                            required
                            type="number"
                            variant="underlined"
                            label={"GPI No"}
                            placeholder={tripData?.gpiNo}
                            onWheel={(e) => e.target.blur()}
                            isDisabled
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            name="ton"
                            isRequired
                            required
                            type="number"
                            variant="underlined"
                            label="Ton"
                            placeholder={tripData?.ton}
                            isDisabled
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="lrNo"
                            type="number"
                            variant="underlined"
                            label="LR No"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.lrNo}
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className="w-3/5"
                            name="destination"
                            isRequired
                            required
                            type="text"
                            variant="underlined"
                            label="Destination"
                            placeholder={tripData?.destination}
                            isDisabled
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="truckNo"
                            isRequired
                            required
                            type="text"
                            variant="underlined"
                            label="Truck No"
                            placeholder={tripData?.truckNo}
                            isDisabled
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className=""
                            name="threePointAmount"
                            type="number"
                            variant="underlined"
                            label="3 point Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.threePointAmount}
                            isDisabled={(tripData?.threePointAmount && user?.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className=""
                            name="threePointBill"
                            type="text"
                            variant="underlined"
                            label="3 point Bill"
                            placeholder={tripData?.threePointBill}
                            isDisabled={(tripData?.threePointBill && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className=""
                            name="threePointDate"
                            type="date"
                            variant="underlined"
                            label="3 point Date"
                            placeholder={tripData?.threePointDate ? new Date(tripData?.threePointDate).toLocaleDateString() : ""}
                            isDisabled={(user.role !== "Admin") ? true : false}
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            name="companyRate"
                            type="number"
                            variant="underlined"
                            label="Company Rate"
                            onWheel={(e) => e.target.blur()}
                            placeholder={" " + tripData?.companyRate}
                            isDisabled={(tripData?.companyRate && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="lorryRate"
                            type="number"
                            variant="underlined"
                            label="Lorry Rate"
                            onWheel={(e) => e.target.blur()}
                            placeholder={" " + tripData?.lorryRate}
                            isDisabled={(tripData?.lorryRate && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="balanceAmount"
                            type="number"
                            variant="underlined"
                            label="Lorry Balance"
                            className='text-red-600'
                            onWheel={(e) => e.target.blur()}
                            placeholder={" " + tripData?.balanceAmount}
                            isDisabled
                        />
                        {/* <span className="w-[1px] h-10 mt-4 bg-black"></span> */}
                        {/* <Input
              name="totalAmount"
              type="number"
              variant="underlined"
              label="Total Amount"
              
            /> */}
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className="w-3/5"
                            name="soldToParty"
                            type="text"
                            variant="underlined"
                            label="Sold To Party"
                            placeholder={tripData?.soldToParty}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="contactNo"
                            className="w-2/5"
                            type="number"
                            variant="underlined"
                            label="Contact No"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.contactNo}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="lorryTotal"
                            className="w-2/5"
                            type="number"
                            variant="underlined"
                            label="Lorry Total"
                            placeholder={tripData?.lorryTotal}
                            isDisabled
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            name="advancedAmount"
                            type="number"
                            variant="underlined"
                            label="Advanced Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={" " + tripData?.advancedAmount}
                            isDisabled={(tripData?.advancedAmount && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className='max-w-44'
                            name="advancedAmountDate"
                            type="date"
                            variant="underlined"
                            label={tripData?.advancedAmountDate
                                ? "Advanced Amount Date: " + new Date(tripData.advancedAmountDate).toLocaleDateString("en-GB")
                                : "Advanced Amount Date "}
                            isDisabled={(user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Select
                            selectedKeys={selectedAdvancedRemark}
                            name='advanceAmountRemark' label="Advance-Amount Remark"
                            onChange={(e) => setSelectedAdvancedRemark([e.target.value])}
                        >
                            <SelectItem key="CASH">
                                CASH
                            </SelectItem>
                            <SelectItem key="UPI">
                                UPI
                            </SelectItem>
                            <SelectItem key="NEFT">
                                NEFT
                            </SelectItem>
                        </Select>
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="dieselAmount"
                            type="number"
                            variant="underlined"
                            label="Diesel Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={" " + tripData?.dieselAmount}
                            isDisabled={(tripData?.dieselAmount && user.role !== "Admin") ? true : false}
                        />


                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className="w-3/5"
                            name="billNo"
                            type="text"
                            variant="underlined"
                            label="Bill No"
                            placeholder={tripData?.billNo}
                            isDisabled={(tripData?.billNo && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            name="billDate"
                            className="w-2/5"
                            type="date"
                            variant="underlined"
                            label={tripData?.billDate ? "Bill Date: " + new Date(tripData?.billDate)?.toLocaleDateString("en-GB") : "Bill Date: "}
                            placeholder={tripData?.billDate ? new Date(tripData?.billDate).toLocaleDateString("en-GB") : ""}
                            isDisabled={(user.role !== "Admin") ? true : false}
                        />

                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            name="tollBillNo"
                            className="w-2/5"
                            type="text"
                            variant="underlined"
                            label={"Toll-Bill-No "}
                            placeholder={tripData?.tollBillNo}
                            isDisabled={(tripData?.tollBillNo && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className="w-3/5"
                            name="tollAmount"
                            type="text"
                            variant="underlined"
                            label="Toll Amount"
                            placeholder={" " + tripData?.tollAmount}
                            isDisabled={(tripData?.tollAmount && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className="w-3/5"
                            name="tollDate"
                            type="date"
                            variant="underlined"
                            label={tripData?.tollDate ? "Toll-bill Date: " + new Date(tripData?.tollDate)?.toLocaleDateString("en-GB") : "Toll-bill Date:"}
                            placeholder={tripData?.tollDate ? new Date(tripData?.tollDate).toLocaleDateString("en-GB") : ""}
                            isDisabled={(user.role !== "Admin") ? true : false}
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className="w-3/5"
                            name="postPaidAmount"
                            type="number"
                            variant="underlined"
                            label="Post Paid Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.postPaidAmount}
                            isDisabled={!(tripData?.lorryRate) ? true : (tripData?.postPaidAmount && user?.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        {/* <Input
                            className="w-3/5"
                            name="postPaidAmountRemark"
                            type="text"
                            variant="underlined"
                            label="Post Paid Amount Remark"
                            placeholder={tripData?.postPaidAmountRemark}
                            isDisabled={!(tripData?.lorryRate) ? true : (tripData?.postPaidAmountRemark && user?.role !== "Admin") ? true : false}
                        /> */}
                        <Select name='postPaidAmountRemark'
                            selectedKeys={postpaidRemark1}
                            onChange={(e) => setPostpaidRemark1([e.target.value])}
                            label="Post Paid Amount Remark" isDisabled={!(tripData?.lorryRate) ? true : (tripData?.postPaidAmountRemark && user?.role !== "Admin") ? true : false}>
                            <SelectItem key="CASH">
                                CASH
                            </SelectItem>
                            <SelectItem key="UPI">
                                UPI
                            </SelectItem>
                            <SelectItem key="NEFT">
                                NEFT
                            </SelectItem>
                        </Select>
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className="w-3/5"
                            name="postPaidDate"
                            type="date"
                            variant="underlined"
                            label={tripData?.postPaidDate ? "Post Paid Date " + new Date(tripData?.postPaidDate)?.toLocaleDateString("en-GB") : "Post Paid Date "}

                            placeholder={tripData?.postPaidDate ? new Date(tripData?.postPaid2Date).toLocaleDateString("en-GB") : ""}
                            isDisabled={(user.role !== "Admin") ? true : false}
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className="w-3/5"
                            name="postPaid2Amount"
                            type="number"
                            variant="underlined"
                            label="Post Paid 2 Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.postPaid2Amount}
                            isDisabled={!(tripData?.lorryRate) ? true :
                                (tripData.postPaid2Amount && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        {/* <Input
                            className="w-3/5"
                            name="postPaidAmountRemark2"
                            type="text"
                            variant="underlined"
                            label="Post Paid Amount Remark 2"
                            placeholder={tripData?.postPaidAmountRemark2}
                            isDisabled={!(tripData?.lorryRate) ? true : (tripData?.postPaidAmountRemark2 && user?.role !== "Admin") ? true : false}
                        /> */}
                        <Select name='postPaidAmountRemark2'
                            selectedKeys={postpaidRemark2}
                            onChange={(e) => setPostpaidRemark2([e.target.value])}
                            label="Post Paid Amount Remark 2" isDisabled={!(tripData?.lorryRate) ? true : (tripData?.postPaidAmountRemark2 && user?.role !== "Admin") ? true : false}>
                            <SelectItem key="CASH">
                                CASH
                            </SelectItem>
                            <SelectItem key="UPI">
                                UPI
                            </SelectItem>
                            <SelectItem key="NEFT">
                                NEFT
                            </SelectItem>
                        </Select>
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className="w-3/5"
                            name="postPaid2Date"
                            type="date"
                            variant="underlined"
                            label={tripData?.postPaid2Date ? "Post Paid 2 Date " + new Date(tripData?.postPaid2Date)?.toLocaleDateString("en-GB") : "Post Paid 2 Date "}

                            placeholder={tripData?.postPaid2Date ? new Date(tripData?.postPaid2Date).toLocaleDateString("en-GB") : ""}
                            isDisabled={(user.role !== "Admin") ? true : false}
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className="w-3/5"
                            name="postPaid3Amount"
                            type="number"
                            variant="underlined"
                            label="Post Paid 3 Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.postPaid3Amount}
                            isDisabled={!(tripData?.lorryRate) ? true :
                                (tripData.postPaid3Amount && user.role !== "Admin") ? true : false
                            }
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        {/* <Input
                            className="w-3/5"
                            name="postPaidAmountRemark3"
                            type="text"
                            variant="underlined"
                            label="Post Paid Amount Remark 3"
                            placeholder={tripData?.postPaidAmountRemark3}
                            isDisabled={!(tripData?.lorryRate) ? true : (tripData?.postPaidAmountRemark3 && user?.role !== "Admin") ? true : false}
                        /> */}
                        <Select
                            selectedKeys={postpaidRemark3}
                            onChange={(e) => setPostpaidRemark3([e.target.value])}
                            name='postPaidAmountRemark3' label="Post Paid Amount Remark 3" isDisabled={!(tripData?.lorryRate) ? true : (tripData?.postPaidAmountRemark3 && user?.role !== "Admin") ? true : false}>
                            <SelectItem key="CASH">
                                CASH
                            </SelectItem>
                            <SelectItem key="UPI">
                                UPI
                            </SelectItem>
                            <SelectItem key="NEFT">
                                NEFT
                            </SelectItem>
                        </Select>

                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className="w-3/5"
                            name="postPaid3Date"
                            type="date"
                            variant="underlined"
                            label={tripData?.postPaid3Date ? "Post Paid 3 Date " + new Date(tripData?.postPaid3Date)?.toLocaleDateString("en-GB") : "Post Paid 3 Date "}

                            placeholder={tripData?.postPaid3Date ? new Date(tripData?.postPaid3Date).toLocaleDateString("en-GB") : ""}
                            isDisabled={(user.role !== "Admin") ? true : false}
                        />
                    </div>

                    <div className="flex gap-4 w-full">
                        <Input
                            className="w-3/5"
                            name="extraAmount"
                            type="number"
                            variant="underlined"
                            label="Extra Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.extraAmount}
                            isDisabled={(tripData?.extraAmount && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Select
                            selectedKeys={extraAmountRemark}
                            onChange={(e) => setExtraAmountRemark([e.target.value])}
                            name='extraAmountRemark' label="Extra amount remark"
                            isDisabled={(tripData?.extraAmountRemark && user.role !== "Admin") ? true : false}
                        >
                            <SelectItem key="CASH">
                                CASH
                            </SelectItem>
                            <SelectItem key="UPI">
                                UPI
                            </SelectItem>
                            <SelectItem key="NEFT">
                                NEFT
                            </SelectItem>
                        </Select>

                    </div>
                    {/* 
                    <div className="flex gap-4 w-full">
                    </div> */}

                    <div className="flex gap-4 w-full">
                        <Input
                            className=""
                            name="unloading"
                            type="number"
                            variant="underlined"
                            label="Unloading"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.unloading}
                            isDisabled={(tripData?.unloading && user.role !== "Admin") ? true : false}
                        />
                        <span className="w-[1px] h-10 mt-4 bg-black"></span>
                        <Input
                            className=""
                            name="incentiveAmount"
                            type="number"
                            variant="underlined"
                            label="Incentive Amount"
                            onWheel={(e) => e.target.blur()}
                            placeholder={tripData?.incentiveAmount}
                            isDisabled={(tripData?.incentiveAmount && user.role !== "Admin") ? true : false}
                        />



                    </div>

                    <Button
                        type="submit"
                        color="primary"
                        className="m-4 w-2/5 rounded-md">
                        Submit
                    </Button>

                </form >
            </div >

        </>
    )
}

export default UpdateTrip;